<!--
 * @Description: 试题 详情
 * @Author: PF
 * @Date: 2022-09-23 11:53:38
 * @LastEditors: PF
 * @LastEditTime: 2025-07-17 15:39:55
-->
<template>
  <div>
    <el-dialog class="wp90 hp90" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="el-row" style="margin-left: -10px; margin-right: -10px;">
        <div class="el-col el-col-18" style="padding-left: 10px; padding-right: 10px;">
          <div class="el-card content is-always-shadow">
            <div class="el-card__body">
              <div class="content-title">
                <div class="name">{{ruleForm.zymc}}</div>
                <el-button type="warning" class="h35 w100" @click="openQuanPing=true">全屏预览</el-button>
                <el-button v-if="ruleForm.sfysc" type="success" class="h35 w100" @click="quXiaoShouCang"><el-icon class="el-icon--left">
                    <Star />
                  </el-icon>取消收藏</el-button>
                <el-button v-else type="success" class="h35 w100" @click="openShouCang=true"><el-icon class="el-icon--left">
                    <Star />
                  </el-icon>收藏</el-button>
                <el-button type="primary" class="h35 w100" @click="xiaZai">下载</el-button>
              </div>
              <!-- {{glj + dqwj.wjlj + dqwj.wjmc}} -->
              <div class="video">
                <div class="flexBox-common" style="align-items: flex-start;">
                  <div class="flexBox-common zywjBox" style="flex: 1 1 0%;" v-loading="loading" element-loading-background="rgba(122, 122, 122, 0.8)">
                    <embed v-if="dqwj.wjlx==='pdf'" class="teaplan_iframe" :src="glj + dqwj.wjlj + dqwj.wjmc" style="position:absolute; left: 0; top: 0;" width="100%" height="100%" type="application/pdf" />
                    <video v-else-if="dqwj.wjlx==='mp4'" controls="" autoplay="" name="media" style="width:100%;height:100%;"><source :src="glj + dqwj.wjlj + dqwj.wjmc" type="video/mp4"></video>
                    <video v-else-if="dqwj.wjlx==='3gp'" controls="" autoplay="" name="media" style="width:100%;height:100%;"><source :src="glj + dqwj.wjlj + dqwj.wjmc" type="video/3gpp"></video>
                    <img v-else-if="dqwj.wjlx==='gif' || dqwj.wjlx==='jpg' || dqwj.wjlx==='png' || dqwj.wjlx==='svg'" :src="glj + dqwj.wjlj + dqwj.wjmc" style="width: 100%;height: 100%;object-fit: contain;display: block;-webkit-user-select: none;margin: auto;background-color: hsl(0, 0%, 90%);" :onload="officeJiaZai" />
                    <iframe v-else-if="dqwj.wjlx==='txt'" :src="glj + dqwj.wjlj + dqwj.wjmc" width='100%' height='100%' frameborder='1' ></iframe>
                    <vue-office-docx v-else-if="dqwj.wjlx==='docx'" :src="glj + dqwj.wjlj + dqwj.wjmc" style="width: 100%;height: 100%;" @rendered="officeJiaZai" />
                    <vue-office-excel v-else-if="dqwj.wjlx==='xlsx'" :src="glj + dqwj.wjlj + dqwj.wjmc" style="width: 100%;height: 100%;" @rendered="officeJiaZai" />
                    <div v-else style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;">当前文件不可预览</div>
                  </div>
                  <div class="zyListBox tree-overflow-x">
                    <div class="el-scrollbar" style="height: 100%;">
                      <div class="el-scrollbar__wrap">
                        <div class="el-scrollbar__view">
                          <div class="zyFileItem " :class="curFile===index?'curFile':''" v-for="(item, index) in ruleForm.listZywj" :key="index" @click="wjClick(item, index)"><span class="fileOrder">文件{{ index+1 }}</span><span>{{ item.wjymc }}</span></div>
                        </div>
                      </div>
                      <div class="el-scrollbar__bar is-horizontal">
                        <div class="el-scrollbar__thumb" style="transform: translateX(0%);"></div>
                      </div>
                      <div class="el-scrollbar__bar is-vertical">
                        <div class="el-scrollbar__thumb" style="transform: translateY(0%);"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="rigth-card tjCard" style="padding: 20px 10px 0px;">
                <div id="Echart" style="width:100%; height: 280px"></div>
              </div>
              <div class="comment">
                <div class="write-title">评论({{ ruleForm.plcs }})</div>
                <div class="write-comment">
                  <div class="user-img">
                    <el-image style="width: 50px; height: 50px" :src="glj + userInfo.zp" fit="cover">
                      <template #error>
                        <div class="image-slot">
                          <el-icon style="font-size: 4em;background-color: #ebeff1;width: 100%;height: 100%;">
                            <User />
                          </el-icon>
                        </div>
                      </template>
                    </el-image>
                  </div>
                  <div class="user-textarea">
                    <div class="commScore">
                      <div>已评分：</div>
                      <el-rate v-model="pingLun.pf" void-color="#C6D1DE" />
                    </div>
                    <div class="el-textarea el-input--medium"><el-input v-model="pingLun.plnr" :rows="5" type="textarea" placeholder="请输入评论" resize="none" /></div>
                    <div class="textarea-btn">
                      <button type="button" class="el-button el-button--default el-button--medium" style="width: 100px; margin-top: 20px;" @click="pingLun.plnr='';pingLun.pf=''"><span>重 置</span></button>
                      <button type="button" class="el-button el-button--primary el-button--medium" style="width: 100px; margin-top: 20px;" @click="pingLunClick()"><span>评 论</span></button>
                    </div>
                  </div>
                </div>
                <div class="all-title">全部评论</div>
                <div>
                  <div class="comment-list">
                    <div class="comment-item" v-for="(item, index) in plData" :key="index">
                      <div class="user-img">
                        <el-image style="width: 50px; height: 50px" :src="glj + item.zp" fit="cover">
                          <template #error>
                            <div class="image-slot" style="text-align: center;">
                              <span class="iconfont icon-geren" style="font-size: 38px; color: #73767a;"></span>
                            </div>
                          </template>
                        </el-image>
                      </div>
                      <div class="comment-content">
                        <div style="display: flex; justify-content: space-between;">
                          <div class="comment-name"> {{item.plrxm}} </div>
                          <el-rate v-model="item.pf" disabled disabled-void-color="#EFF2F7" />
                        </div>
                        <div class="comment-info">{{item.plnr}}</div>
                        <div class="comment-time">{{item.plsj}}</div>
                      </div>
                    </div>
                  </div>
                  <pagination :pagination="page" @ReturnData="initPingLun" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="el-col el-col-6" style="padding-left: 10px; padding-right: 10px;">
          <div class="el-card rigth-card is-always-shadow">
            <div class="el-card__body">
              <el-image style="width: 120px; height: 120px; margin-bottom: 15px;" :src="glj + ruleForm.slt" fit="cover">
                <template #error>
                  <div class="image-slot">
                    <el-image style="width: 120px; height: 120px;" src="/image/ziyuanmorentu1.png" fit="contain" />
                  </div>
                </template>
              </el-image>
              <div class="card-item-second">
                <div class="item-label">关键字</div>
                <div class="item-value">{{ruleForm.gjz}}</div>
              </div>
              <div class="card-item-second">
                <div class="item-label">资源简介</div>
                <div class="item-value">
                  <p style="white-space: pre-wrap; text-indent:0;" v-html="ruleForm.zyjj"></p>
                </div>
              </div>
            </div>
          </div>
          <div class="el-card rigth-card is-always-shadow">
            <div class="el-card__body">
              <div class="card-item">
                <div class="item-label">作者</div>
                <div class="item-value">{{ ruleForm.zyzz }}</div>
              </div>
              <div class="card-item">
                <div class="item-label">语种</div>
                <div class="item-value">{{ ruleForm.zyyzbt }}</div>
              </div>
              <div class="card-item">
                <div class="item-label">资源大小</div>
                <div class="item-value">{{ ruleForm.zydx }}M</div>
              </div>
              <div class="card-item">
                <div class="item-label">上传人</div>
                <div class="item-value">{{ ruleForm.scrxm }}</div>
              </div>
              <div class="card-item">
                <div class="item-label">上传时间</div>
                <div class="item-value">{{ ruleForm.scsj }}</div>
              </div>
              <div class="card-item">
                <div class="item-label">资源类型</div>
                <div class="item-value">{{ ruleForm.zylxbt }}</div>
              </div>
              <div class="card-item">
                <div class="item-label">资源库</div>
                <div class="item-value">{{ ruleForm.zykmc }}</div>
              </div>
              <div class="card-item">
                <div class="item-label">所属专业</div>
                <div class="item-value">{{ ruleForm.zydmmc }}</div>
              </div>
              <div class="card-item">
                <div class="item-label">资源来源</div>
                <div class="item-value">{{ ruleForm.zyly }}</div>
              </div>
              <div class="card-item">
                <div class="item-label">关联课程</div>
                <div class="item-value">{{ ruleForm.kcmc }}</div>
              </div>
              <div class="card-item">
                <div class="item-label">关联教材</div>
                <div class="item-value">{{ ruleForm.jcmc }}</div>
              </div>
              <div class="card-item">
                <div class="item-label">关联单元</div>
                <div class="item-value">{{ ruleForm.jxdybt }}</div>
              </div>
              <div class="card-item">
                <div class="item-label">关联内容</div>
                <div class="item-value">{{ ruleForm.jxnrbt }}</div>
              </div>
              <div class="card-item">
                <div class="item-label">知识点</div>
                <div class="item-value">{{ ruleForm.zsd }}</div>
              </div>
            </div>
          </div>
          <div class="el-card rigth-card is-always-shadow">
            <div class="el-card__body">
              <div class="card-download">
                <div class="card-title">查看次数</div>
                <div class="card-totle"> 总计：{{ ruleForm.ckcs }}次 </div>
                <div class="card-content">
                  <div>今日：{{ tongji.jrckcs }}</div>
                  <div>昨日：{{ tongji.zrckcs }}</div>
                  <div>本周：{{ tongji.zckcs }}</div>
                </div>
              </div>
              <div class="card-download">
                <div class="card-title">下载次数</div>
                <div class="card-totle"> 总计：{{ ruleForm.xzcs }}次 </div>
                <div class="card-content">
                  <div>今日：{{ tongji.jrxzcs }}</div>
                  <div>昨日：{{ tongji.zrxzcs }}</div>
                  <div>本周：{{ tongji.zxzcs }}</div>
                </div>
              </div>
              <div class="card-download">
                <div class="card-title">评论次数</div>
                <div class="card-totle"> 总计：{{ ruleForm.plcs }}次 </div>
                <div class="card-content">
                  <div>今日：{{ tongji.jrplcs }}</div>
                  <div>昨日：{{ tongji.zrplcs }}</div>
                  <div>本周：{{ tongji.zplcs }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
  <detailshoucang v-if="openShouCang" v-model:openAdd="openShouCang" :row="{id:ruleForm.id}" @ReturnData="initInfo()" />
  <el-dialog v-model="openQuanPing" title="全屏预览" class="wp100 hp100" :before-close="handleClose" v-loading="loading">
    <embed v-if="dqwj.wjlx==='pdf'" class="teaplan_iframe" :src="glj + dqwj.wjlj + dqwj.wjmc" type="application/pdf" style="position:absolute; left: 0; top: 0;" width="100%" height="100%">
    <video v-else-if="dqwj.wjlx==='mp4'" controls="" autoplay="" name="media" style="width:100%;height:100%;"><source :src="glj + dqwj.wjlj + dqwj.wjmc" type="video/mp4"></video>
    <video v-else-if="dqwj.wjlx==='3gp'" controls="" autoplay="" name="media" style="width:100%;height:100%;"><source :src="glj + dqwj.wjlj + dqwj.wjmc" type="video/3gpp"></video>
    <img v-else-if="dqwj.wjlx==='gif' || dqwj.wjlx==='jpg' || dqwj.wjlx==='png' || dqwj.wjlx==='svg'" :src="glj + dqwj.wjlj + dqwj.wjmc" style="width: 100%;height: 100%;object-fit: contain;display: block;-webkit-user-select: none;margin: auto;background-color: hsl(0, 0%, 90%);">
    <iframe v-else-if="dqwj.wjlx==='txt'" :src="glj + dqwj.wjlj + dqwj.wjmc" width='100%' height='99%' frameborder='1' ></iframe>
    <vue-office-docx v-else-if="dqwj.wjlx==='docx'" :src="glj + dqwj.wjlj + dqwj.wjmc" style="width: 100%;height: 100%;" @rendered="officeJiaZai" />
    <vue-office-excel v-else-if="dqwj.wjlx==='xlsx'" :src="glj + dqwj.wjlj + dqwj.wjmc" style="width: 100%;height: 100%;" @rendered="officeJiaZai" />
    <div v-else style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;">当前文件不可预览</div>
  </el-dialog>
</template>

<script setup>
import * as echarts from 'echarts'
import { defineEmits, ref, defineProps, watch } from 'vue'
import {
  loadData,
  closeWindow,
  actionPost,
  submitDataGridAction
} from '@/api/common.js'
import { successPrompt, warningPrompt } from '@/utils/promptInfo.js'
import { download } from '@/utils/requestDownload.js'
import pagination from '@/components/pagination.vue'
import detailshoucang from './detailshoucang'
import VueOfficeDocx from '@vue-office/docx'
import '@vue-office/docx/lib/index.css'
import VueOfficeExcel from '@vue-office/excel'
import '@vue-office/excel/lib/index.css'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDetail', 'ReturnData'])

const userInfo = ref({})

// 文件点击
const glj = ref() // 根路径
const curFile = ref(0)
const loading = ref(false)
const wjClick = (item, index) => {
  loading.value = false
  if (item.wjlx === 'docx' || item.wjlx === 'xlsx') {
    loading.value = true
  }
  curFile.value = index
  dqwj.value = item
}
const officeJiaZai = () => {
  loading.value = false
}
// 获取详情
const dqwj = ref('')
const ruleForm = ref({})
const initInfo = () => {
  loadData({
    url: '/api/v2/ziyuan/ziyuan/' + row.value.id,
    ruleForm: ruleForm,
    loadSuccess: function (res) {
      if (res.data.listZywj.length) {
        res.data.listZywj.forEach((element) => {
          element.wjlx = element.wjmc.substring(
            element.wjmc.lastIndexOf('.') + 1
          )
        })
        dqwj.value = res.data.listZywj[0]
      }
    }
  })
}
// 获取统计
const tongji = ref({})
const initTongJi = () => {
  loadData({
    url: '/api/v2/ziyuan/ziyuan/tongji/' + row.value.id,
    ruleForm: tongji,
    loadSuccess: function (res) {
      getEchar()
    }
  })
}
const getEchar = () => {
  const lookData = []
  const commonData = []
  const downLoadData = []
  const dateData = []
  tongji.value.recentlySeven.forEach((item) => {
    downLoadData.push(item.downNum)
    lookData.push(item.lookNum)
    commonData.push(item.commNum)
    dateData.push(item.time)
  })

  const option = {
    // backgroundColor: '#080b30',//整个幕布背景色
    title: {
      // echarts主标题样式
      text: '近一周统计次数',
      textStyle: {
        align: 'center',
        // color: '#888888',
        fontSize: 16,
        fontWeight: 600
      },
      top: '0',
      left: 'center'
    },
    tooltip: {
      // 鼠标滑过交叉点的提示样式，默认是黑色半透明状态
      trigger: 'axis',
      axisPointer: {
        label: {
          // X轴坐标文字样式
          show: true,
          backgroundColor: '#fff',
          color: '#556677',
          borderColor: 'rgba(0,0,0,0)',
          shadowColor: 'rgba(0,0,0,0)',
          shadowOffsetY: 0
        },
        lineStyle: {
          width: 0
        }
      },
      backgroundColor: '#fff',
      textStyle: {
        color: '#5c6c7c'
      },
      padding: [10, 10],
      extraCssText: 'box-shadow: 1px 0 2px 0 rgba(163,163,163,0.5)'
    },
    legend: {
      // 右上角线类型标记
      data: ['查看次数', '下载次数', '评论次数'],
      orient: 'vertical',
      left: 'center',
      padding: 5,
      bottom: 'bottom',
      icon: 'circle', // 图标点样式
      itemWidth: 6,
      itemGap: 20,
      // data: charts.names,
      textStyle: {
        fontSize: 12,
        color: '#151619'
      }
    },
    //
    grid: {
      top: '20%',
      left: '4%',
      right: '5%',
      bottom: '10%',
      containLabel: true
    },
    // 横坐标设置
    xAxis: {
      type: 'category',
      boundaryGap: false, // 坐标轴两边留白
      axisLabel: {
        // 坐标轴刻度标签的相关设置。
        interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
        // margin:15,
        textStyle: {
          color: '#1B253A',
          fontStyle: 'normal',
          fontFamily: '微软雅黑',
          fontSize: 12
        }
        // rotate:50,
      },
      axisTick: {
        // 坐标轴刻度相关设置。
        show: false
      },
      axisLine: {
        // 坐标轴轴线相关设置
        lineStyle: {
          color: '#D9D9D9'
          // opacity:0.2
        }
      },
      splitLine: {
        // 坐标轴在 grid 区域中的分隔线。
        show: false,
        lineStyle: {
          color: '#E5E9ED'
          // opacity:0.1
        }
      },
      data: dateData
    },
    // 纵坐标设置
    yAxis: {
      name: '单位：次', // Y轴坐标名称 or 单位
      splitLine: {
        lineStyle: {
          // grid 区域内横坐标的线样式 此时为虚线
          type: 'dashed',
          color: '#D9D9D9'
        }
      }
    },
    series: [
      {
        name: '查看次数',
        type: 'line',
        smooth: true,
        itemStyle: {
          normal: {
            color: '#F88940',
            // 交叉点的阴影样式
            shadowBlur: 3,
            shadowColor: 'rgba(3,3,3,0.5)',
            shadowOffsetY: 8,
            lineStyle: {
              color: '#F88940',
              // 以下为线的阴影样式
              shadowBlur: 3,
              shadowColor: 'rgba(3,3,3,0.5)',
              shadowOffsetY: 8,
              width: 1
            },
            areaStyle: {
              // 曲线图覆盖的地方为渐变色
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0,
                  color: 'rgba(248,137,64,0)'
                },
                {
                  offset: 1,
                  color: 'rgba(248,137,64,0.35)'
                }
              ])
            }
          }
        },
        symbol: 'circle', // 数据交叉点样式
        symbolSize: 5, // 数据交叉点尺寸
        data: lookData
      },
      {
        name: '下载次数',
        type: 'line',
        smooth: true,
        itemStyle: {
          normal: {
            color: '#6B97FE',
            lineStyle: {
              color: 'rgba(107,151,254)',
              width: 1
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0,
                  color: 'rgba(107,151,254,0)'
                },
                {
                  offset: 1,
                  color: 'rgba(107,151,254,0.35)'
                }
              ])
            }
          }
        },
        data: downLoadData
      },
      {
        name: '评论次数',
        type: 'line',
        smooth: true,
        itemStyle: {
          normal: {
            color: '#8b5cff',
            lineStyle: {
              color: 'rgba(139,92,255)',
              width: 1
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0,
                  color: 'rgba(139,92,255,0)'
                },
                {
                  offset: 1,
                  color: 'rgba(139,92,255,0.35)'
                }
              ])
            }
          }
        },
        data: commonData
      }
    ]
  }
  const Echart = echarts.init(document.getElementById('Echart'))
  Echart.setOption(option)
}
// 评论
const plData = ref([])
const page = ref({})
const pingLun = ref({ pf: 0, plnr: '' })
// 评论列表
const initPingLun = async (pageNo, pageSize) => {
  const data = {
    zyid: row.value.id,
    pageNo: pageNo || 1,
    pageSize: pageSize || 10,
    menuId: sessionStorage.getItem('menuId')
  }
  const options = {
    url: '/api/v2/ziyuan/ziyuanpinglun/wodepinglunziyuan',
    data: data
  }
  actionPost(options).then((res) => {
    if (res.code === 200) {
      plData.value = res.data.list
      page.value = {
        pageNo: data.pageNo,
        pageSize: data.pageSize,
        pageSizes: [10, 20, 30, 40, 50],
        total: res.data.total
      }
    } else {
      warningPrompt(res.message)
    }
  })
}
// 添加评论
const pingLunClick = () => {
  const data = {
    zyid: row.value.id,
    pf: pingLun.value.pf,
    plnr: pingLun.value.plnr,
    menuId: sessionStorage.getItem('menuId')
  }
  const options = { url: '/api/v2/ziyuan/ziyuanpinglun', data: data }
  actionPost(options).then((res) => {
    if (res.code === 200) {
      pingLun.value = { pf: 0, plnr: '' }
      initInfo()
      initTongJi()
      initPingLun()
      emits('ReturnData')
    } else {
      warningPrompt(res.message)
    }
  })
}
const row = ref()
watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      glj.value = process.env.VUE_APP_BASE_API
      row.value = props.row
      userInfo.value = JSON.parse(sessionStorage.getItem('USER_INFO'))
      initInfo()
      initTongJi()
      initPingLun()
    }
  },
  { deep: true, immediate: true }
)
const openQuanPing = ref(false)
const handleClose = () => {
  openQuanPing.value = false
}
// 收藏
const openShouCang = ref(false)
const quXiaoShouCang = () => {
  const dataGrid = { multipleSelection: [row.value.id] }
  submitDataGridAction({
    url: '/api/v2/ziyuan/ziyuanshoucang',
    dataGrid: dataGrid,
    confirmTitle: '确定要删除吗?',
    method: 'delete',
    callback: function (res) {
      initInfo()
      emits('ReturnData')
    }
  })
}

// 下载
const xiaZai = () => {
  const data = { zyid: row.value.id, menuId: sessionStorage.getItem('menuId') }
  const options = { url: '/api/v2/ziyuan/ziyuanxiazai', data: data }
  actionPost(options).then((res) => {
    if (res.code === 200) {
      download(glj.value + dqwj.value.wjlj + dqwj.value.wjmc, dqwj.value.wjymc)
      emits('ReturnData')
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
</script>
<style lang="less" scoped>
// :deep(.vue-office-docx-main) {
//   height: 100%;
// }
// :deep(.docx-wrapper) {
//   height: 100%;
//   overflow: auto;
// }
// :deep(.docx) {
//   width: 100%;
//   height: 100%;
// }
.el-icon--left {
  color: #fff;
}
.content-title {
  display: flex;
  .name {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    line-height: 25px;
    font-weight: bold;
    font-size: 16px;
  }
}
.video {
  width: 100%;
  height: calc(100vh - 250px);
  border: 1px solid #ccc;
  margin-top: 10px;
  .flexBox-common {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    .zywjBox {
      height: calc(100vh - 252px);
      width: calc(100% - 240px);
      // background: #404040;
      .teaplan_iframe {
        height: calc(100vh - 252px);
        width: 100%;
      }
    }

    .zyListBox {
      width: 240px;
      background: #f7f7f7;
      height: calc(100vh - 252px);
      margin-left: 10px;
      padding: 0 10px;
      .tree-overflow-x .el-scrollbar__wrap {
        overflow-x: hidden !important;
        padding-right: 10px;
      }
      .curFile {
        color: #1890ff;
        font-weight: bold;
      }
      .zyFileItem {
        word-wrap: break-word;
        word-break: break-all;
        line-height: 25px;
        border-bottom: 1px solid #eee;
        padding: 10px 0;
        font-size: 15px;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        .fileOrder {
          font-weight: bold;
          margin-right: 10px;
        }
      }
    }
  }
}
.rigth-card {
  background-color: #fff;
  padding: 20px;
  margin-bottom: 20px;
}
.comment {
  margin-top: 20px;
  .write-title {
    font-size: 23px;
    line-height: 40px;
    margin-bottom: 10px;
  }
  .write-comment {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    .user-img {
      width: 50px;
      height: 50px;
      overflow: hidden;
      border-radius: 50%;
    }
    .user-textarea {
      -webkit-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
      margin-left: 20px;
      .commScore {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        align-items: center;
        margin: 10px 0;
        :deep(.el-rate__icon) {
          color: #99a9bf;
        }
        :deep(.is-active) {
          color: #f7ba2a;
        }
      }
      .el-input--medium {
        font-size: 14px;
      }
      .textarea-btn {
        text-align: right;
      }
    }
  }
  .all-title {
    font-size: 20px;
    line-height: 40px;
    margin-bottom: 10px;
    border-bottom: 1px solid #f0f0f0;
  }
  .comment-list {
    margin-top: 20px;
    .comment-item {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      border-bottom: 1px solid #f0f0f0;
      padding: 20px 0;
      .user-img {
        width: 50px;
        height: 50px;
        overflow: hidden;
        border-radius: 50%;
      }
      .comment-content {
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        margin-left: 20px;
        .comment-name {
          font-weight: 600;
          height: 32px;
          line-height: 32px;
          font-size: 16px;
        }
        .comment-info {
          line-height: 24px;
          font-size: 14px;
        }
        .comment-time {
          text-align: right;
          color: #999;
          font-size: 14px;
          margin-top: 10px;
        }
        :deep(.el-rate__icon) {
          color: #99a9bf;
        }
        :deep(.is-active) {
          color: #f7ba2a;
        }
      }
    }
    .comment-item:last-child {
      border-bottom: none;
    }
    .user-img {
      width: 50px;
      height: 50px;
      overflow: hidden;
      border-radius: 50%;
    }
  }
  .pagination-container {
    background: #fff;
    padding: 20px 16px 0;
    text-align: right;
  }
}
.card-item-second {
  font-size: 14px;
  .item-value {
    margin: 10px 0;
    line-height: 18px;
    color: #838383;
  }
}
.card-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  font-size: 14px;
  margin-bottom: 16px;
  .item-value {
    color: #838383;
  }
}
.card-download {
  margin-bottom: 16px;
  font-size: 14px;
  .card-title {
    text-align: center;
  }
  .card-totle {
    text-align: right;
    font-size: 14px;
  }
  .card-content {
    margin-top: 10px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
}
</style>
